// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1R--O","header":"ReportDetails_header__aazS-","title":"ReportDetails_title__1JW4Y","left":"ReportDetails_left__3fQCZ"};